import React from "react";
import "./Login.css";
import { useForm } from "react-hook-form";
import { useState } from "react";

function Login(props) {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(!show);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    console.log(data)
  handleShow();
  };

  return (
    <div className="login">
      <i className="far fa-user" onClick={handleShow}></i>
      {show && (
        <div className=" login-menu text-center">
          <h2>Login</h2>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form">
              <span>
                <i className="fas fa-user"></i>
              </span>

              <input
                type="email"
                className="form-input"
                name="email"
                placeholder="Email"
                {...register("email", { required: "Email is required" })}
              />
            </div>
            <div className="validate-massage">
              {errors.email && <p>{errors.email.message}</p>}
            </div>
            <div className="form">
              <span>
                <i className="fas fa-lock"></i>
              </span>
              <input
                type="password"
                className="form-input"
                placeholder="Password"
                name="password"
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 5,
                    message: "Password should have more than 5 characters",
                  },
                  maxLength: {
                    value: 12,
                    message: "Password should have less than 12 characters",
                  },
                })}
              />
            </div>
            <div className="validate-massage">
              {errors.password && <p>{errors.password.message}</p>}
            </div>
            <div className=" form-check">
              <input type="checkbox" className="form-check-input" />
              <label className="form-check-label">Remember me</label>
            </div>
            <button  type="submit" className="btn ">
              Login
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

export default Login;
